module.exports = __webpack_public_path__ + "static/deezer-background-9bdbf6192014b5a846b31f6ededdbbae.mp4";